import { Position } from '@fluentui/react';
import { FC, useCallback } from 'react';
import { nameof } from '../../utils/stringUtils';
import { formatNum } from '../../utils/timeUtils';
import { CustomWidthSpinButton } from '../../shared/styled-components';

interface IProps {
    value: number;
    onChange(value: number): void;
    min?: number;
    max?: number;
    step?: number;
    id?: string;
    label?: string;
    inlineLabel?: boolean;
    disabled?: boolean;
    width?: string | number;
    showLeadingZero?: boolean;
}

export type INumberSpinButtonProps = IProps;

const NumberSpinButton: FC<IProps> = ({ value, onChange, min, max, step, id, label, inlineLabel, disabled, width, showLeadingZero }) => {

    const readStringValue = useCallback(
        (val: string | undefined) => {
            const numValue = val ? Number.parseInt(val) : (min ?? 0);
            return isNaN(numValue)
                ? min ?? 0
                : numValue;
        },
        [min],
    );

    const updateValue = useCallback(
        (val: number) => {
            if (min !== undefined && val < min)
                val = min;
            if (max !== undefined && val > max)
                val = max;

            onChange(val);
        },
        [max, min, onChange],
    );

    return (
        <CustomWidthSpinButton id={id}
            label={label}
            labelPosition={inlineLabel ? undefined : Position.top}
            disabled={disabled}
            value={showLeadingZero ? formatNum(value) : value.toString()}
            onChange={(_, val) => updateValue(readStringValue(val))}
            inputProps={{ onKeyDown: (e) => { if (e.key === 'Enter') updateValue(readStringValue((e.target as EventTarget & HTMLInputElement).value)); } }}
            onBlur={(e) => updateValue(readStringValue(e.target.value))}
            step={step}
            styles={{ root: { width } }}
            min={min}
            max={max}
        />
    );
};

NumberSpinButton.displayName = nameof({ NumberSpinButton });
export default NumberSpinButton;